import "../assets/styles/components/reaction-list.scss";
import Na from "../assets/icons/reaction/na";
import Reaction4 from "../assets/icons/reaction/reaction-4";
import Reaction3 from "../assets/icons/reaction/reaction-3";
import Reaction2 from "../assets/icons/reaction/reaction-2";
import Reaction1 from "../assets/icons/reaction/reaction-1";
import Reaction0 from "../assets/icons/reaction/reaction-0";
import { useEffect, useState } from "react";

export default function ReactionList({ check_list, question_id }) {
  const [selected, setSelected] = useState();

  useEffect(() => {
    if (check_list && check_list.jsonAnswers && question_id != null) {
      let answer = JSON.parse(check_list.jsonAnswers).find(
        (x) => x.questionId === question_id
      )?.idValutazione;

      setSelected(answer);
    }
  }, [check_list, question_id]);

  useEffect(() => {
    if (selected != null)
      document.querySelector(
        `#question_${question_id}_${selected}`
      ).checked = true;
  }, [selected]);

  return (
    <div className="reaction-list d-flex w-100 my-3">
      <div className="position-relative my-2 mx-auto">
        <Reaction0
          onClick={() =>
            check_list && !check_list.isConfirmed ? setSelected(0) : null
          }
          size={38}
          color="#cccccc"
          active={selected === 0}
        />
        <input
          type="radio"
          className="position-absolute p-0 m-0"
          id={`question_${question_id}_0`}
          name={`question_${question_id}`}
          value="0"
          required
        />
      </div>
      <div className="position-relative my-2 mx-auto">
        <Reaction1
          onClick={() =>
            check_list && !check_list.isConfirmed ? setSelected(1) : null
          }
          size={38}
          color="#cccccc"
          active={selected === 1}
        />
        <input
          type="radio"
          className="position-absolute p-0 m-0"
          id={`question_${question_id}_1`}
          name={`question_${question_id}`}
          value="1"
          required
        />
      </div>
      <div className="position-relative my-2 mx-auto">
        <Reaction2
          onClick={() =>
            check_list && !check_list.isConfirmed ? setSelected(2) : null
          }
          size={38}
          color="#cccccc"
          active={selected === 2}
        />
        <input
          type="radio"
          className="position-absolute p-0 m-0"
          id={`question_${question_id}_2`}
          name={`question_${question_id}`}
          value="2"
          required
        />
      </div>
      <div className="position-relative my-2 mx-auto">
        <Reaction3
          onClick={() =>
            check_list && !check_list.isConfirmed ? setSelected(3) : null
          }
          size={38}
          color="#cccccc"
          active={selected === 3}
        />
        <input
          type="radio"
          className="position-absolute p-0 m-0"
          id={`question_${question_id}_3`}
          name={`question_${question_id}`}
          value="3"
          required
        />
      </div>
      <div className="position-relative my-2 mx-auto">
        <Reaction4
          onClick={() =>
            check_list && !check_list.isConfirmed ? setSelected(4) : null
          }
          size={38}
          color="#cccccc"
          active={selected === 4}
        />
        <input
          type="radio"
          className="position-absolute p-0 m-0"
          id={`question_${question_id}_4`}
          name={`question_${question_id}`}
          value="4"
          required
        />
      </div>
      <div className="position-relative my-2 mx-auto">
        <Na
          onClick={() =>
            check_list && !check_list.isConfirmed ? setSelected(5) : null
          }
          size={38}
          color="#cccccc"
          active={selected === 5}
        />
        <input
          type="radio"
          className="position-absolute p-0 m-0"
          id={`question_${question_id}_5`}
          name={`question_${question_id}`}
          value="5"
          required
        />
      </div>
    </div>
  );
}
